export default [
    {
        path: '/personas/lista-persona',
        name: 'personas-lista-persona',
        component: () => import('@/views/pages/personas/lista-persona/ListaPersona.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Personas',
            action: 'ver-personas-lista-personas',
            pageTitle: 'Lista Persona',
            breadcrumb: [
                {
                    text: 'Lista Persona',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/personas/editar-persona/:Codigo',
        name: 'personas-editar-persona',
        component: () => import('@/views/pages/personas/editar-persona/EditarPersona.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Personas',
            action: 'ver-personas-editar-personas',
            pageTitle: 'Editar Persona',
            breadcrumb: [
                {
                    text: 'Editar Persona',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/personas/crear-persona',
        name: 'personas-crear-persona',
        component: () => import('@/views/pages/personas/crear-persona/CrearPersona.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Personas',
            action: 'ver-personas-crear-personas',
            pageTitle: 'Crear Persona',
            breadcrumb: [
                {
                    text: 'Crear Persona',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/personas/mantenimiento/listadoEntidades',
        name: 'personas-mantenimiento-listado-entidades',
        component: () => import('@/views/pages/personas/mantenimiento/ListadoEntidades.vue'),
        meta: {
            title: 'i18n:personas.mantenimiento.page.lista_entidades',
            resource: 'Personas',
            action: 'ver-personas-mantenimiento-listado-entidades',
            // pageTitle: 'Lista de Entidades',
            breadcrumb: [
                {
                    text: 'Personas',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Lista de Entidades',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/personas/mantenimiento/agregarEntidad',
        name: 'personas-mantenimiento-agregar-entidad',
        component: () => import('@/views/pages/personas/mantenimiento/AgregarEntidad.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Personas',
            action: 'ver-personas-mantenimiento-agregar-entidad',
            pageTitle: 'Agregar Entidad',
            breadcrumb: [
                {
                    text: 'Personas',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Agregar Entidad',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/personas/mantenimiento/editarEntidad/:id_entidad',
        name: 'personas-mantenimiento-editar-entidad',
        component: () => import('@/views/pages/personas/mantenimiento/EditarEntidad.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Personas',
            action: 'ver-personas-mantenimiento-editar-entidad',
            pageTitle: 'Editar Entidad',
            breadcrumb: [
                {
                    text: 'Personas',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Editar Entidad',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/personas/transaccion/chequeoPersonal',
        name: 'personas-transacciones-chequeo-personal',
        component: () => import('@/views/pages/personas/chequeoPersonal.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Personas',
            action: 'ver-personas-transacciones-chequeo-personal',
            pageTitle: 'Chequeo de Personal',
            breadcrumb: [
                {
                    text: 'Chequeo de Personal',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/personas/mantenimiento/cuentas-contables',
        name: 'personas-mantenimiento-cuentas-contables',
        component: () => import('@/views/pages/personas/CuentasContables.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Personas',
            action: 'ver-personas-mantenimiento-cuentas-contables',
            pageTitle: 'Cuentas Contables',
            breadcrumb: [
                {
                    text: 'Proveedor',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/personas/mantenimiento/cliente-local',
        name: 'personas-mantenimiento-cliente-local',
        component: () => import('@/views/pages/personas/mantenimiento/maestroClienteLocal.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Personas',
            action: 'ver-personas-mantenimiento-cliente-local',
            pageTitle: 'Cliente Local',
            breadcrumb: [
                {
                    text: 'Personas',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Cliente Local',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/personas/mantenimiento/permisos-categoria',
        name: 'personas-mantenimiento-permisos-categoria',
        component: () => import('@/views/pages/personas/mantenimiento/maestroPermisosCategoria.vue'),
        meta: {
            title: 'i18n:',
            resource: 'Personas',
            action: 'ver-personas-mantenimiento-permisos-categoria',
            pageTitle: 'Permisos por Categoria',
            breadcrumb: [
                {
                    text: 'Personas',
                },
                {
                    text: 'Mantenimiento',
                },
                {
                    text: 'Permisos por Categoria',
                    active: true,
                },
            ],
        },
    },
]
